<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Professional Resourcing</h2>
            <ul>
                <li>
                    <a href="/">Home</a>
                </li>
                <li>Professional Resourcing</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>Professional Resourcing</h3>
                    <p>With years of experience in both the IT field and recruitment, we are able to provide our clients
                        with the resources to
                        fill niche skill requirements. We have formulated a highly effective process of recruiting,
                        screening, testing, and
                        consultant management. We offer five models of Resourcing to match any of our clients’ needs
                        including contract (short,
                        medium and long term), contract-to-hire and permanent placement. Our consultants are proficient
                        in the IT field and are
                        deadline oriented to meet the needs of our clients.
                    </p>
                    <h3>BENEFITS OF PROFESSIONAL RESOURCING</h3>
                    <p>Save Money – Reduce overhead costs by hiring IT consultants on a project basis rather than hiring
                        an additional
                        full-time employee.
                        Save Time – Let us bring on one of our expert consultants who has been screened and tested to
                        best suit your specific
                        business requirements.
                        Industry Experience – Our years of expertise, global partnerships, and teams of highly skilled
                        professionals will help
                        find the best match to meet all your IT objectives.</p>

                    <div class="services-details-features">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="features-image">
                                    <img src="assets/img/services-details/services-details-2.jpg" alt="image">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <ul class="features-list">
                                    <li><i class="flaticon-check"></i> Direct & Turnkey professional services</li>
                                    <li><i class="flaticon-check"></i> Executive search</li>
                                    <li><i class="flaticon-check"></i> Staff Augmentation</li>
                                    <li><i class="flaticon-check"></i> Contract Consulting</li>
                                    <li><i class="flaticon-check"></i> Contract to Hire</li>
                                    <li><i class="flaticon-check"></i> Direct Hire</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->

<!-- Services -->
<section class="services-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Related Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/software-outsourcing-services">
                            <img src="assets/img/services/services-8.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/software-outsourcing-services">Software Outsourcing</a>
                        </h3>
                        <span>Contact us for more details</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/it-consulting-services">
                            <img src="assets/img/services/services-9.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/it-consulting-services">IT Consulting Services</a>
                        </h3>
                        <span>Contact us for more details</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services -->